<template>
    <v-menu bottom left>
        <template v-slot:activator="{ on, attrs }">
            <v-btn icon tile v-bind="attrs" v-on="on">
                <v-icon color="blue-grey" v-on="on">
                    mdi-dots-horizontal-circle
                </v-icon>
            </v-btn>
        </template>

        <slot />
    </v-menu>
</template>

<script>
export default {}
</script>

<style></style>
